import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ListEcoleComponent } from './listecole.component';
import { AuthGuard } from '../../auth/auth-guard.service';
import { EcoleComponent } from './ecole.component';

const routes: Routes = [
  {
    path: '',
    component: EcoleComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'liste',
        component: ListEcoleComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EcoleRoutingModule { }

export const routedComponents = [
  EcoleComponent,
  ListEcoleComponent
];
